module.exports = __webpack_public_path__ + "img/Apoptosis-PRCA_10X_AIC.148b36df.png";